export const required = (value: string) => value ? undefined : 'Поле обязательно для заполнения';
